/** @jsx h */

const TeaserOrte = ({ result }) => {
  function handleCopyrightButtonClick(e) {
    const container = e.target.closest('.caption');
    const buttonTarget = e.currentTarget;
    const isExpanded = buttonTarget.getAttribute('aria-expanded') === 'true';

    buttonTarget.setAttribute('aria-expanded', !isExpanded);
    container.classList.toggle('is-open');
  }
  return (
    <article className="search-result__article">
      <div className="search-result__content">
        <header className="search-result__header">
          {result.mark && <span>{result.mark}</span>}
          <h3 className="search-result__heading">
            {result.url ? (
              <a
                className={`styled-link styled-link--internal  ${
                  result.isExternal ? 'styled-link--icon' : ''
                }`}
                href={result.url}
                {...(result.isExternal
                  ? { target: '_blank', rel: 'noopener' }
                  : '')}
              >
                {result.isExternal ? (
                  <span class="styled-link__icon icon icon--extern">
                    <svg class="icon__svg" role="img" aria-hidden="true">
                      <use href="#icon-extern" />
                    </svg>
                  </span>
                ) : (
                  ''
                )}
                <span className="styled-link__text">{result.title}</span>
              </a>
            ) : (
              result.title
            )}
          </h3>
        </header>
        <p className="search-result__subtext">{result.subtitle}</p>
        {result.teaser && (
          <p
            className="search-result__text"
            dangerouslySetInnerHTML={{
              __html: result.teaser,
            }}
          />
        )}
      </div>
      <div class="search-result__details">
        {result.image && (
          <figure class="search-result__figure">
            <picture>
              <img
                className="search-result__image"
                src={result.image.src}
                alt={result.image.alt}
                title={result.image.title}
              />
            </picture>
            {result.image.copyright && (
              <figcaption class="search-result__caption caption caption--external-link">
                <div class="caption__content">
                  {result.image.copyright}
                  {result.image.licenseUrl && (
                    <a
                      class="styled-link styled-link--external "
                      href={result.image.licenseUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span class=" icon icon--extern">
                        <svg class="icon__svg" role="img" aria-hidden="true">
                          <use href="#icon-extern" />
                        </svg>

                        <span class="sr-only">Externer Link</span>
                      </span>

                      <span class="styled-link__text">
                        {result.image.licenseTitle || 'CC-BY-SA 2.0'}
                      </span>
                    </a>
                  )}
                </div>
                <button
                  class="caption__button-copyright styled-button"
                  type="button"
                  aria-expanded="false"
                  onClick={handleCopyrightButtonClick}
                >
                  <span class="icon icon--copyright">
                    <svg class="icon__svg" role="img" aria-hidden="true">
                      <use href="#icon-copyright" />
                    </svg>
                    <span class="sr-only">Urheberrecht</span>
                  </span>
                  <span class="icon icon--close">
                    <svg class="icon__svg" role="img" aria-hidden="true">
                      <use href="#icon-close" />
                    </svg>
                    <span class="sr-only">schließen</span>
                  </span>
                </button>
              </figcaption>
            )}
          </figure>
        )}
      </div>
    </article>
  );
};

export default TeaserOrte;
